exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2uLbgjb9boSzfxBJnK_vsd{font-size:13px;color:#757575;margin-bottom:20px}.SjmfYWIM1pMeZEBxEeI-k{margin-bottom:8px}\n", ""]);

// Exports
exports.locals = {
	"imageHint": "_2uLbgjb9boSzfxBJnK_vsd",
	"imageUploadWithNote": "SjmfYWIM1pMeZEBxEeI-k"
};